module.exports = __webpack_public_path__ + "img/docs_admin.d797c76f.svg";